import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step.description;

export const getDescription = ({ step: { details }, t }) => {
  return t('Transcribe Audio from ‘{{fieldName}}’ field', {
    fieldName: details?.sourceField?.label || t('File'),
  });
};

export default function AudioTranscriptionCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
